import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/constants/queryKeys';
import { getContentAuthorProfile } from '@/services/api/requests/content';

// Public profile + stats for a content author. Pass `enabled` to skip the fetch for
// platform (MyOmnia) content, which has no creator profile.
const useContentAuthorProfile = (userId?: string | null, enabled = true) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [queryKeys.content.author, userId],
    queryFn: () => getContentAuthorProfile(userId as string),
    enabled: Boolean(userId) && enabled,
  });

  return { profile: data, isLoading, isError, refetch };
};

export default useContentAuthorProfile;
